export const buttonVariants = {
  primary: 'primary',
  primary_light: 'primary_light',
  secondary: 'secondary',
  red: 'red',
  primary_rounded: 'primary_rounded',
};
export const buttonSizes = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  icon_only: 'icon_only',
};
